import { useState, useEffect } from 'react';
import { onAuthStateChanged, getIdTokenResult } from 'firebase/auth';
import { auth } from '../firebase'; // Adjust the path to your firebase config
import { useNavigate } from 'react-router-dom';

const useAdminAuth = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [userId, setUserId] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true); // اطمینان از اینکه loading در ابتدای هر بررسی true است
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setUserId(user.uid);
        try {
          const idTokenResult = await getIdTokenResult(user, true);
          // console.log('ID Token Result from useAdminAuth:', idTokenResult); 
          if (idTokenResult.claims.role === 'admin') {
            setIsAdmin(true);
            // console.log('useAdminAuth: User is admin');
          } else {
            setIsAdmin(false);
            // console.log('useAdminAuth: User is logged in, but NOT admin.');
            // ریدایرکت در اینجا انجام نمی‌شود، به عهده ProtectedAdminRoute خواهد بود
          }
        } catch (error) {
          console.error('useAdminAuth: Error getting ID token result:', error);
          setIsAdmin(false);
          // ریدایرکت در اینجا انجام نمی‌شود
        }
      } else {
        // No user logged in
        setIsAdmin(false);
        setUserId(null);
        // console.log('useAdminAuth: No user logged in, redirecting to admin-login...');
        navigate('/admin-login', { replace: true }); // هدایت به صفحه لاگین ادمین
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [navigate]);

  return { isAdmin, loading, userId };
};

export default useAdminAuth; 